<template>
  <layout>
    <page-header :actions="actions" :header="pageHeader" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps" @api-result="onApiResult">
        <template slot="order.amount" slot-scope="{ item }">
          {{ item.order.amount | currency(item.currency_label) }}
        </template>
        <template slot="payout_amount" slot-scope="{ item }">
          {{ item.payout_amount | currency(item.currency_label) }}
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import PayoutsApi from './PayoutsApi'
import UsersApi from '../users/UsersApi'

export default {
  name: 'Payouts',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: 'payouts',
        apiBuilder: () => {
          return new PayoutsApi().setParameters({
            'where[user_id]': this.$route.params.user_id,
            include: 'order',
          })
        },
        columns: [
          {
            key: 'order.created_at',
            label: this.$t('general.date'),
            component: 'value-date',
            config: {
              time: false,
            },
          },
          {
            key: 'order.description',
            label: this.$t('orders.description'),
          },
          {
            key: 'order.amount',
            label: this.$t('affiliates.order_amount'),
          },
          {
            key: 'commission',
            label: this.$t('affiliates.commission'),
            formatter: value => (value ? `${value}%` : null),
          },
          {
            key: 'status_label',
            label: this.$t('affiliates.status'),
          },
          {
            key: 'payout_amount',
            label: this.$t('affiliates.payout_amount'),
          },
        ],

        searchFields: [
          {
            component: 'select-field',
            attribute: 'where[status]',
            placeholder: this.$t('affiliates.status'),
            options: [
              {
                label: this.$t('affiliates.payout_status.pending'),
                value: 'pending',
              },
              {
                label: this.$t('affiliates.payout_status.complete'),
                value: 'complete',
              },
            ],
          },
          {
            component: 'text-field',
            attribute: 'order_like',
            placeholder: this.$t('affiliates.order'),
          },
        ],

        rowActions: () => [],

        bulkActions: () => {
          return [
            {
              label: this.$t('affiliates.generate_invoice'),
              handler: selected => {
                this.generateInvoice(selected)
              },
            },
          ]
        },
      },
      user: null,
      currency: '',
      totals: {},
    }
  },

  computed: {
    pageHeader() {
      return this.$t('affiliates.payouts_title', {
        name: this.user ? this.user.name : '...',
      })
    },
    // Page header actions
    actions() {
      if (!this.totals.pending) {
        return []
      }

      return [
        {
          id: 'create',
          text: this.$t('affiliates.generate_invoice'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.generateInvoice()
          },
        },
      ]
    },
  },

  mounted() {
    new UsersApi().find(this.$route.params.user_id).then(result => {
      this.user = result.data
    })
  },

  methods: {
    onApiResult(result) {
      this.currency = result.currency_label
      this.totals = result.totals
    },
    generateInvoice(ids) {
      new PayoutsApi()
        .process(ids, this.user.id)
        .then(result => {
          this.$toast.success(result.message)
          this.$refs.table.refresh()
        })
        .catch(result => {
          this.$toast.error(result.data.message)
        })
    },
  },
}
</script>
